import {contractApi} from "@/axios";
export function reportPage(params, data) {
    return contractApi({
        url: '/method-template/page',
        method: 'post',
        params:params,
        data: data
    })
}
export function downloadTemplate(hexCode) {
    return contractApi({
        url: '/method-template/download/'+hexCode,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//获取更新日志
export function getMethodLog(params) {
    return contractApi({
        url: '/log/update/get-log',
        method: 'get',
        params: params
    });
}